import './DatePickerMixRangeField.css';

import { cn } from '##/utils/bem';

export const cnDatePickerMixRangeField = cn('DatePickerMixRangeField');
